import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLink: false,
    menuData: [],
    token: null,
    curMenu: '',
    //左侧菜单是否显示
    leftMenuVisible: undefined,
    //左侧菜单的父菜单ID
    leftMenuPID: "",
    //当前选中的左侧菜单
    curLeftMenu: "",
    //iframe嵌套三方页面时，iframe 的src地址，这里用来跨页面传值，防止src显示到浏览器的url中
    iframeLayoutSrc: "",
    projectInfo:"",
    userInfo:"",
    attrInfo:"",//扩展属性信息
    isSetLeftMenu:null,
    ywAudit:'',//运维审核权限
  },
  getters: {
    getCurMenu: state => {
      if (!state.curMenu) {
        return window.sessionStorage.getItem("curMenu");
      } else {
        return state.curMenu;
      }
    },
    getIframeLayoutSrc: state => {
      if (state.iframeLayoutSrc) {
        return state.iframeLayoutSrc;
      }
      else {
        return window.sessionStorage.getItem("iframeLayoutSrc");
      }

    }
   
  },
  mutations: {
    saveIsLink(state, data) {
      state.isLink = data;
    },
    saveToken(state, data) {
      state.token = data;
      window.localStorage.setItem("Token", data);
    },
    saveMenuData(state, data) {
      state.menuData = data;
    },
    saveProjectData(state, data) {
      state.projectInfo = data;
    },
    saveYunWeiInfo(state, data) {
      state.yunWeiInfo = data;
    },
    setCurMenu(state, data) {
      state.curMenu = data;
      window.sessionStorage.setItem("curMenu", data);
    },
    saveIsSetLeftMenu(state, isSetLeftMenu) {
      state.isSetLeftMenu = isSetLeftMenu;
    },
    saveLeftMenuVisible(state, data) {
      state.leftMenuVisible = data;
    
    },
    saveLeftMenuPID(state, data) {
      state.leftMenuPID = data;
     
    },
    saveCurLeftMenu(state, data) {
      state.CurLeftMenu = data;
      window.sessionStorage.setItem("curLeftMenu", data);
    },
    saveIframeLayoutSrc(state, data) {
      state.iframeLayoutSrc = data;
      window.sessionStorage.setItem("iframeLayoutSrc", data);
    },
    saveCurStationType(state,data){
      state.curStationType=data;
    },
    saveCurUserInfo(state, data) {
      state.userInfo = data;
    },
    saveCurUserAttr(state, data) {
      state.attrInfo = data;
    },
    saveYWAudit(state, data) {
      state.ywAudit = data;
    }
  },
  actions: {
  },
  modules: {
  }
})
